var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Button } from 'syf-component-library/ui/atoms';
import { fontSizes, spacing } from 'syf-component-library/defaultTheme';
import query from 'syf-component-library/const/mediaQueries';
import { useDispatch } from 'react-redux';
import { t } from '../../../strings/i18n/i18n';
import Icon from '../../../ui/atoms/Icon';
import { openModal } from '../../../redux/ui/ui.slice';
import { ModalType } from '../../../redux/ui/typings';
import { getLanguageFromStorage } from 'syf-js-utilities';
var FAQButtonWrapper = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: unset;\n  padding: unset;\n  min-width: unset;\n  margin: unset;\n  overflow: unset;\n  font-size: ", "px;\n  white-space: nowrap;\n\n  @media ", " {\n    ", "\n  }\n"], ["\n  height: unset;\n  padding: unset;\n  min-width: unset;\n  margin: unset;\n  overflow: unset;\n  font-size: ", "px;\n  white-space: nowrap;\n\n  @media ", " {\n    ", "\n  }\n"])), fontSizes.root, query.greaterThanMedium, function (_a) {
    var $language = _a.$language;
    return $language === 'es' &&
        "\n    width: 215px;\n    min-width: 205px;\n    white-space: wrap;\n    text-align: left;\n    align-items: flex-start;\n\n    svg {\n      margin-top: 2px;\n    }\n  ";
});
var QuestionMarkIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: ", "px;\n"], ["\n  margin-right: ", "px;\n"])), spacing.xsmall);
var FAQButton = function () {
    var dispatch = useDispatch();
    var language = getLanguageFromStorage();
    var handleClick = function () {
        dispatch(openModal(ModalType.FAQs));
    };
    return (_jsxs(FAQButtonWrapper, __assign({ "data-cy": "faq-button", "data-type": "dispute-transaction", "data-title": "dispute-transaction", "data-reason": "Disputes FAQs", "data-object": "link", "data-analytics": "clicktrackingevent", className: "ensightencustomevent", buttonType: "text", onClick: handleClick, "$language": language }, { children: [_jsx(QuestionMarkIcon, { name: "falCircleQuestion", size: "lg" }), t('faqs.link')] })));
};
export default FAQButton;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map